import { z } from 'zod';
import { isPlayerBlockingType } from '../../../types/playerBlockingTypes';
import { playerMedalsParser } from '../pokerInbounds/utils/medalInboundUtils';
import { playerStyleStringParser } from '../pokerInbounds/utils/playerStyleInboundUtils';
import { optionalAvatarPropertiesSetParser } from './utils/playerAvatarInboundUtils';
import { playerIdNameParser } from './utils/playerInboundUtils';
const ShowPlayerInfoInboundSchema = z
    .object({
    playerIdName: z.string().transform(playerIdNameParser),
    isPowerPlayer: z.boolean(),
    numChipsInBank: z.number(),
    avatarJson: z.string().transform(optionalAvatarPropertiesSetParser),
    medalsDtoString: z.string().transform(playerMedalsParser),
    blockingTypes: z.array(z.custom(isPlayerBlockingType)),
    playerStyleString: z.string().transform(playerStyleStringParser),
    bio: z.string().optional(),
    statsFields: z.array(z.tuple([z.string(), z.string()])).optional(),
    restrictedStatsFields: z.array(z.tuple([z.string(), z.string()])).optional()
})
    .transform(
// rename fields and add _type
({ avatarJson, medalsDtoString, playerStyleString, ...rest }) => ({
    _type: 'player_info',
    avatarPropertiesSet: avatarJson,
    medals: medalsDtoString,
    playerStyle: playerStyleString,
    ...rest
}));
export const SHOW_PLAYER_INFO_PAYLOAD_DEFINITION = {
    zodSchema: ShowPlayerInfoInboundSchema
};
